import { render, staticRenderFns } from "./withdrawalRequest.vue?vue&type=template&id=4d6052f9&scoped=true"
import script from "./withdrawalRequest.vue?vue&type=script&lang=js"
export * from "./withdrawalRequest.vue?vue&type=script&lang=js"
import style0 from "./withdrawalRequest.vue?vue&type=style&index=0&id=4d6052f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6052f9",
  null
  
)

export default component.exports